import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import Creatable from 'react-select/creatable';
import {
  siteId, openedFolder, openedFile, fileFetchIsLoading, fileFetchHasErrored, fileStructure,
  isFileStructureShowing, revision, sourceRevision, targetRevision, xmlSourceFile, xmlTargetFile,
} from '../actions/actionCreator';
import accounts from '../assets/json/accounts.json';

const mapStateToProps = (state) => ({
  siteIdCurrent: state.siteId,
  showingFolders: state.isFileStructureShowing,
});

const mapDispatchToProps = (dispatch) => ({
  siteId: (account) => dispatch(siteId(account)),
  openedFolder: (folder) => dispatch(openedFolder(folder)),
  openedFile: (file) => dispatch(openedFile(file)),
  fileFetchIsLoading: (isLoading) => dispatch(fileFetchIsLoading(isLoading)),
  fileFetchHasErrored: (hasErrored) => dispatch(fileFetchHasErrored(hasErrored)),
  fileStructure: (files) => dispatch(fileStructure(files)),
  revision: (revisionLoaded) => dispatch(revision(revisionLoaded)),
  isFileStructureShowing: (bool) => dispatch(isFileStructureShowing(bool)),
  sourceRevision: (rev) => dispatch(sourceRevision(rev)),
  targetRevision: (rev) => dispatch(targetRevision(rev)),
  xmlSourceFile: (file) => dispatch(xmlSourceFile(file)),
  xmlTargetFile: (file) => dispatch(xmlTargetFile(file)),
});

// Pre-build options once at module scope — accounts.json is bundled and
// static; no need to rebuild on every render or every keystroke.
const ACCOUNT_OPTIONS = accounts.map((a) => ({ value: a, label: a }));
const ACCOUNT_SET = new Set(accounts);
const MIN_QUERY_LENGTH = 5;

class AccountFinder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSiteId: null,
      inputValue: '',
    };
  }

  goToSiteId(value) {
    this.props.siteId(value);
    this.props.openedFolder('config');
    this.props.openedFile('');
    this.props.isFileStructureShowing(true);
    this.props.fileStructure({});
    this.props.revision({});
    this.props.sourceRevision(0);
    this.props.targetRevision(0);
    this.props.xmlSourceFile('');
    this.props.xmlTargetFile('');

    this.props.callDVS(
      this.props.fileFetchIsLoading,
      this.props.fileFetchHasErrored,
      this.props.fileStructure,
      'FILE_STRUCTURE',
      value,
    );
    this.props.routeHandler('FILE_STRUCTURE', value);
  }

  componentDidMount() {
    if (this.props.accountQueryString) {
      this.props.callDVS(
        this.props.fileFetchIsLoading,
        this.props.fileFetchHasErrored,
        this.props.fileStructure,
        'FILE_STRUCTURE',
        this.props.accountQueryString,
      );
    }
  }

  render() {
    return (
      <Form className={`${this.props.siteIdCurrent === '' ? 'no-site' : ''} account-selector`}>
        <Creatable
          options={ACCOUNT_OPTIONS}
          isClearable={false}
          placeholder="Begin by typing a site ID"
          value={this.state.selectedSiteId}
          inputValue={this.state.inputValue}
          onInputChange={(input, { action }) => {
            // react-select v5 fires onInputChange for several actions
            // (input-change, input-blur, menu-close, set-value). Only
            // 'input-change' represents real keystrokes.
            if (action === 'input-change') this.setState({ inputValue: input });
          }}
          // Suppress "Create 'X'" until the user has typed at least
          // MIN_QUERY_LENGTH characters AND the typed value isn't already a
          // real account (avoids the misleading "Create timexotics" UX when
          // timexotics already exists in the bundled list).
          isValidNewOption={(input) => (
            input.length >= MIN_QUERY_LENGTH && !ACCOUNT_SET.has(input)
          )}
          // Hide the suggestions dropdown entirely until the user is past
          // the gate; matches the legacy "Type at least 5 characters" UX.
          filterOption={(option, raw) => {
            if (raw.length < MIN_QUERY_LENGTH) return false;
            return option.label.includes(raw);
          }}
          noOptionsMessage={({ inputValue }) => (
            (inputValue || '').length < MIN_QUERY_LENGTH
              ? `Type at least ${MIN_QUERY_LENGTH} characters`
              : 'No sites found'
          )}
          onChange={(option) => {
            if (option && option.value) {
              this.props.fileFetchHasErrored(false);
              this.setState({ selectedSiteId: option, inputValue: '' });
              this.goToSiteId(option.value);
            }
          }}
        />
      </Form>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountFinder);
